module.exports = __webpack_public_path__ + "img/3-4-IMG_3001.02f80ea6.png";